export function isDevelopment() {
  return process.env.APP_ENV === 'development';
}

export function isStaging() {
  return process.env.APP_ENV === 'staging';
}

export function isProduction() {
  return process.env.APP_ENV === 'production';
}

export function isServer() {
  return typeof window === 'undefined';
}

export const BASE_URL = `https://${process.env.APP_HOST}:${process.env.APP_PORT}`;
export const API_EMBED_BASE_URL = process.env.API_EMBED || '';
